import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import { PermissionType } from '@fullyops/legacy/ui/ui-shared/utils/crm-types';
import { UiAuthService } from '@fullyops/legacy/ui/ui-crm/ui-auth.service';

@Directive({ selector: '[hideIfNotAllowed]' })
export class HideIfNotAllowedDirective implements OnInit {
  @Input({ alias: 'hideIfNotAllowed' })
  permissions?: readonly PermissionType[];

  isPermissionApproved = true;

  constructor(
    private el: ElementRef,
    private authService: UiAuthService,
  ) {}

  ngOnInit() {
    if (this.permissions == null || this.permissions.length === 0) {
      return;
    }

    this.authService.hasPermission(this.permissions).subscribe((allowed) => {
      if (!allowed) {
        this.el.nativeElement.style.display = 'none';
      }
    });
  }
}
